import { ParsingError } from './parsing-error';

/** Ошибка парсинга аргумента шаблона */
export class ArgumentParsingError extends ParsingError {
    constructor(argument: string) {
        super(`argument "${argument}" parsing error occurred`);
        this.name = 'ArgumentParsingError';
    }
}
